import userModel from '../../../../models/user/user.model';
import ViewBase from '../../../view-base.view';
import UserCreateUdfFormView from '../create/user-create-udf-form.view';

export default function UserEditUdfView() {
    ViewBase.call(this);
    const DEFAULT_COUNTRY = {
        code: '',
        name: '',
        isChanged: true,
        countryMapLoaded: false,
        countryUdfLoaded: false,
        seaoUser: false
    };
    let country = structuredClone(DEFAULT_COUNTRY);

    let _userId = '';
    let udfForm = [];
    let _udfForm = [];
    let _isUdfValid = true;
    let onClose = (isDetailsDtlOpen) => { }

    const getUdf = (udf, isValid) => {
        _udfForm = udf;
        _isUdfValid = isValid;
    }

    const getUserDetails = (encryptedUserId) => {
        userModel.getUserDetails(
            (result) => {
                if (result?.data) {
                    _userId = result.data.userID;
                    setCountryList(result.data.userID, result.data.countryCode);
                }
            },
            (error) => {
                this.handleError(error);
            },
            encryptedUserId);
    }

    const setCountryList = (userId, countryCode) => {
        userModel.getUDFData(
            (result) => {
                let dataArr = [];
                result?.forEach(function (item) {
                    let data = {};
                    data["attributeId"] = item["udfId"].toString();
                    data["attributeName"] = item["udfAttribute"];
                    data["countryCode"] = item["countryCode"];
                    data["countryName"] = item["countryName"];
                    data["type"] = item["dataTypeName"];
                    data["valueId"] = item["udfValueId"].toString();
                    data["valueName"] = item["udfValue"].toString();
                    dataArr.push(data);
                });
                udfForm = dataArr;

                // Has to be called after setting udfForm.
                // As UserCreateUdfForm will only reload udfForm data when countryUdfLoaded = false...
                setCountry(countryCode);
            }, (error) => {
                udfForm = [];
            },
            userId
        );
    }

    const setCountry = (countryCode) => {
        country = structuredClone(DEFAULT_COUNTRY);
        country.code = countryCode;
    };

    const submit = () => {
        this.showLoading();
        let payload = [];
        if (_isUdfValid) {
            _udfForm.forEach(function (item) {
                payload.push({ countryCode: item.countryCode, udfId: item.attributeId.toString(), udfValue: item.type == 'Dropdown' ? item.valueId : item.valueName });
            });

            userModel.editUdf(
                (result) => {
                    this.hideLoading();
                    onClose(false, result);
                }, (error) => {
                    this.hideLoading();
                    this.handleError(error);
                },
                payload, _userId);
        }
        else {
            this.hideLoading();
            this.showErrorMessage(this.getText("EM00000310", "Please fill in all required fields."), this.getText("EM00000142", "Error"));
        }
    }

    return {
        oninit: (vnode) => {
            this.initState(vnode.state);
            onClose = vnode.attrs.onClose;
            getUserDetails(vnode.attrs.encryptedUserId);
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('div',
                        m(UserCreateUdfFormView, { submit: getUdf, defaultCountry: country, udfForm }),
                        m("hr.my-4"),
                        m(".d-grid.g.ap-2.d-sm-flex.justify-content-sm-center",
                            m("button.btn.btn-primary.btn-lg.px-4.gap-3", { style: "margin-right:10px;", onclick: submit }, this.getText("LT00000005", "Submit")),
                        ),
                    ),
                ),
                this.getBaseViews()];
        }
    }
}
